"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.umbCountryStateDropDown = exports.UmbCountryStateDropDown = void 0;
const app_1 = require("app");
const location_1 = require("src/location");
const FormUtils_1 = require("../Forms/FormUtils");
class UmbCountryStateDropDown extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.country-state-dropdown .country-dropdown';
        this.country = '.country-dropdown';
        this.state = '.state-dropdown';
        this.groupSelector = 'fieldset';
        this.umbracoFieldWrapperSelector = '.countrydropdownlist';
        this.fieldValidationValidSelector = '.field-validation-valid';
        this.fieldValidationErrorSelector = '.field-validation-error';
        this.infoMessageHiddenClass = 'info-message-hidden';
        this.fieldValidationHiddenClass = 'field-validation-hidden';
        this.isInfoMessageVisible = false;
        this.embargoCountryMessage = 'Please be informed that Danfoss does not offer requested services in the selected country';
        this.loadStates = (stateService, pageId, countryCode, states) => {
            stateService.getDataForFilterAutoComplete(countryCode).then(data => {
                this.buildOptions(states.select, data);
                states.select.find('option:eq(0)').prop('selected', true);
                states.select.val(states.select.find('option:eq(0)').value);
                this.disableSelect(states.select, false);
            });
        };
    }
    BeforeInit() {
        this.el.forEach(el => {
            this.initCurrentFormControl(el);
        });
    }
    initCurrentFormControl(el) {
        let statesKeyMode = null;
        const countries = this.getSelectObject($(el), this.country, true);
        const states = this.getSelectObject($(el), this.state, false);
        const locationApiUrl = app_1.AttrService.data(el, 'location-api-base-url');
        const locationApiKey = app_1.AttrService.data(el, 'location-api-key');
        const countriesPageId = app_1.AttrService.data(el, 'pageid');
        const culture = app_1.AttrService.data(el, 'culture');
        const countryKeyMode = +app_1.AttrService.data(el, 'keymode');
        this.embargoCountryMessage = app_1.AttrService.data(el, 'embargo-country-error-message');
        if (states) {
            statesKeyMode = +states.wrapper.data('keymode');
        }
        const params = {
            countries,
            states,
            locationApiUrl,
            locationApiKey,
            countriesPageId,
        };
        const services = this.initServices(params, culture, countryKeyMode, statesKeyMode);
        this.initCountries(services, params);
    }
    initServices(params, localCulture, countryKeyMode, statesKeyMode) {
        return this.initCountryStatePair(params, localCulture, countryKeyMode, statesKeyMode);
    }
    initCountryStatePair(params, culture, countryKeyMode, statesKeyMode) {
        const { states, locationApiUrl, locationApiKey } = params;
        const countryService = new location_1.CountryService({
            apiUrl: locationApiUrl,
            locationApiKey,
            culture,
            keyMode: countryKeyMode,
            prefixNeeded: false,
        });
        let stateService = null;
        if (states) {
            stateService = new location_1.StatesService({
                apiUrl: locationApiUrl,
                locationApiKey,
                culture,
                keyMode: statesKeyMode,
                prefixNeeded: false,
            });
        }
        return { countryService, stateService };
    }
    getSelectObject(el, className, isCountry) {
        const wrapper = isCountry ? el : $(className);
        if (!wrapper || !wrapper.length) {
            return null;
        }
        const select = wrapper.find('select');
        const label = wrapper.find('label');
        return {
            label,
            select,
            wrapper,
        };
    }
    initCountries(services, params) {
        const { countries, states } = params;
        const { select, label } = countries;
        const disableSelect = (stateElement, disabled) => {
            this.disableSelect(stateElement, disabled);
        };
        const loadStates = countryValue => {
            this.loadStates(services.stateService, params.countriesPageId, countryValue, states);
        };
        const selectedOption = 'option:selected';
        const placeholderClass = 'placeholder-style';
        const embargoValidationMsg = this.embargoCountryMessage;
        const $umbracoFieldWrapper = select.closest(this.umbracoFieldWrapperSelector);
        services.countryService.getDataForFilterAutoComplete().then(data => {
            this.disableSelect(select, false);
            this.buildOptions(countries.select, data);
            // country select
            select.change(function () {
                const $this = $(this);
                const $selected = $this.find(selectedOption);
                const countryValue = $this.val();
                const countryLabel = $selected.text();
                const countryApiCode = $selected.data('apicode');
                const isEmbargoCountry = (0, FormUtils_1.validateCountry)(countryApiCode);
                $umbracoFieldWrapper.find('input[name=selectedCountryCode]').val(countryApiCode);
                // Embargo country validation
                if (isEmbargoCountry) {
                    $umbracoFieldWrapper.find('.form-wrapper').children('span').eq(0).text('');
                    $umbracoFieldWrapper
                        .find('.form-wrapper')
                        .append(`<p class="countries-validation-error">${embargoValidationMsg}</p>`);
                    $this.parent().addClass('form-control-invalid');
                }
                else {
                    $umbracoFieldWrapper.find('.form-wrapper .countries-validation-error').remove();
                    $this.parent().removeClass('form-control-invalid');
                }
                // set country new label
                label.text(countryLabel).removeClass(placeholderClass);
                // disable state select
                if (states) {
                    disableSelect(states.select, true);
                    if (countryValue) {
                        states.select.val('');
                        states.select.find('option[value]').remove();
                        // set state placeholder label
                        states.label.text(states.select.find('option:eq(0)').text()).addClass(placeholderClass);
                        loadStates(countryApiCode || countryValue);
                    }
                }
            });
            // state select
            if (states) {
                states.select.change(function () {
                    const $this = $(this);
                    const stateTextLabel = $this.find(selectedOption).text();
                    // set state new label
                    states.label.text(stateTextLabel).removeClass(placeholderClass);
                });
            }
        });
    }
    buildOptions(select, data) {
        data.forEach(item => {
            const option = $(`<option value="${item.key.replace(/'/g, '&#92;&apos;')}" data-apicode="${item.internalKey || null}">${item.value}</option>`);
            select.append(option);
        });
    }
    disableSelect(select, disabled) {
        select.attr({ disabled });
        const parent = select.parent();
        disabled
            ? parent.addClass('form-control-disabled')
            : parent.removeClass('form-control-disabled');
    }
}
exports.UmbCountryStateDropDown = UmbCountryStateDropDown;
exports.umbCountryStateDropDown = new UmbCountryStateDropDown();
